import { loadAuthSession } from 'utils/auth/storage';

// Read once at import, which app.js orders after Dev SSO capture.
export const persistedAuthSession = loadAuthSession();
